import Checkbox from '@material-ui/core/Checkbox';
import { FormControlLabel } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { colors } from "../constants/colors";
import FormHelperText from '@mui/material/FormHelperText';

const useStyles = makeStyles({
    root: {
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: colors.orange,
      },
      '& .MuiCheckbox-colorSecondary.Mui-checked.Mui-disabled': {
        color: `${colors.orange} !important`,
      },
    },
    boldDisabledLabel: {
      color: `${colors.black} !important`,
      fontWeight: 'bold',
    },
  });

export const CheckBox = (props) => {  

    const { labelEnableBold = false } = props;
    const classes = useStyles();
    const labelClass = props.disabled && labelEnableBold ? classes.boldDisabledLabel : "";

  return (
    <div className={classes.root}>
      <FormControlLabel  
        control={
          <Checkbox
            disabled={props.disabled}       
            checked={props.checked}
            onChange={props.onChange}      
            {...props}  
          />
        }
        label={props.label}
        classes={{
          label: labelClass,
        }}
      />      
      {props?.helperTextCheck && props?.helperTextCheck !== '' && <FormHelperText style={{color: "#f44336"}}>{props?.helperTextCheck}</FormHelperText>}
    </div>
  );
}